
const deviceSaleRecordModule={
  namespaced: true,
  state:{
    searchSN:''
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default deviceSaleRecordModule;



// WEBPACK FOOTER //
// ./src/store/moudles/deviceSaleRecord.js